import { Table } from "@/features/Table";
import { type A7OPCVMStrategy, getStrategiesColumns } from "./columns";
import {
  FilterA7OPCVMStrategies,
  filterA7OPCVMStrategiesSchema,
} from "./filter";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const table_name = "a7_opcvm_strategies";

export const A7OPCVMStrategiesTable = () => {
  const { t, i18n } = useTranslation(["tables", "common"]);
  const columns = useMemo(() => getStrategiesColumns(t), [t, i18n.language]);

  return (
    <Table<A7OPCVMStrategy, typeof filterA7OPCVMStrategiesSchema>
      label={t(`${table_name}.title`, {
        ns: "tables",
        defaultValue: "Funds",
      })}
      table_name={table_name}
      columns={columns}
      filter={<FilterA7OPCVMStrategies />}
      client="a7"
      disable_translations_request={true}
    />
  );
};
